export function requestTransacoes(idCliente) {
	return {
		type: '@clientDash/REQUEST_TRANSACOES',
		payload: { idCliente },
	};
}

export function successTransacoes(dados) {
	return {
		type: '@clientDash/SUCCESS_TRANSACOES',
		payload: { dados },
	};
}

export function failureTransacoes(error) {
	return {
		type: '@clientDash/FAILURE_TRANSACOES',
		payload: { error },
	};
}

export function requestTransacoesOntem(idCliente) {
	return {
		type: '@clientDash/REQUEST_TRANSACOES_ONTEM',
		payload: { idCliente },
	};
}

export function successTransacoesOntem(dados) {
	return {
		type: '@clientDash/SUCCESS_TRANSACOES_ONTEM',
		payload: { dados },
	};
}

export function failureTransacoesOntem(error) {
	return {
		type: '@clientDash/FAILURE_TRANSACOES_ONTEM',
		payload: { error },
	};
}

export function requestTransacoes30Dias(idCliente) {
	return {
		type: '@clientDash/REQUEST_TRANSACOES_30_DIAS',
		payload: { idCliente },
	};
}

export function successTransacoes30Dias(dados) {
	return {
		type: '@clientDash/SUCCESS_TRANSACOES_30_DIAS',
		payload: { dados },
	};
}

export function failureTransacoes30Dias(error) {
	return {
		type: '@clientDash/FAILURE_TRANSACOES_30_DIAS',
		payload: { error },
	};
}

export function requestBandeiras(params) {
	return {
		type: '@clientDash/REQUEST_BANDEIRAS',
		payload: { params },
	};
}

export function successBandeiras(lista) {
	return {
		type: '@clientDash/SUCCESS_BANDEIRAS',
		payload: { lista },
	};
}

export function failureBandeiras(error) {
	return {
		type: '@clientDash/FAILURE_BANDEIRAS',
		payload: { error },
	};
}

export function requestTopDiasVendas(params) {
	return {
		type: '@clientDash/REQUEST_TOP_DIAS_VENDAS',
		payload: { params },
	};
}

export function successTopDiasVendas(lista) {
	return {
		type: '@clientDash/SUCCESS_TOP_DIAS_VENDAS',
		payload: { lista },
	};
}

export function failureTopDiasVendas(error) {
	return {
		type: '@clientDash/FAILURE_TOP_DIAS_VENDAS',
		payload: { error },
	};
}

export function requestModalidade(params) {
	return {
		type: '@clientDash/REQUEST_MODALIDADE',
		payload: { params },
	};
}

export function successModalidade(lista) {
	return {
		type: '@clientDash/SUCCESS_MODALIDADE',
		payload: { lista },
	};
}

export function failureModalidade(error) {
	return {
		type: '@clientDash/FAILURE_MODALIDADE',
		payload: { error },
	};
}

export function requestRecebimentos(params) {
	return {
		type: '@clientDash/REQUEST_RECEBIMENTOS',
		payload: { params },
	};
}

export function successRecebimentos(lista) {
	return {
		type: '@clientDash/SUCCESS_RECEBIMENTOS',
		payload: { lista },
	};
}

export function failureRecebimentos(error) {
	return {
		type: '@clientDash/FAILURE_RECEBIMENTOS',
		payload: { error },
	};
}

export function requestGraficoEvolutivo(params) {
	return {
		type: '@clientDash/REQUEST_GRAFICO_EVOLUTIVO',
		payload: { params },
	};
}

export function successGraficoEvolutivo(lista) {
	return {
		type: '@clientDash/SUCCESS_GRAFICO_EVOLUTIVO',
		payload: { lista },
	};
}

export function failureGraficoEvolutivo(error) {
	return {
		type: '@clientDash/FAILURE_GRAFICO_EVOLUTIVO',
		payload: { error },
	};
}
